import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import Layout from './Layouts/Layout'
import { StateProvider } from '../store'
import { Api } from '../useFetch'

export default function App() {
    const [staticContents, setStaticContents] = Api({
        method: 'get',
        url: '/api/static-contents'
    })

    const [settings, setSettings] = Api({
        method: 'get',
        url: '/api/settings'
    })

    useEffect(() => {
        setStaticContents()
        setSettings()
    }, [])

    const state = {
        staticContents: staticContents.data,
        ...settings.data
    }

    return (
        <StateProvider initialState={state}>
            <Layout />
        </StateProvider>
    )
}

const appElement = document.getElementById('app')
if (appElement) {
    if (appElement.hasChildNodes()) {
        ReactDOM.hydrate(<Router><App/></Router>, appElement)
    } else {
        ReactDOM.render(<Router><App/></Router>, appElement)
    }
}
